// src/styles/theme.js
export const theme = {
  colors: {
    headerBg: 'rgba(0, 0, 0, 0.8)',
    textLight: '#FFFFFF', // Light text/icons
    accent: '#a7401a',     // Accent color (e.g., orange-red)
    primary: '#333333',    // Primary color for other elements
    textGreen: '#bdd91c',
    headerBgScrolled: 'rgba(0, 0, 0, 0.85)',
    headerBorder: 'rgba(255, 255, 255, 0.1)',
    navHover: 'rgba(255, 255, 255, 0.1)',
    light: '#f0f0f0',
    dark: '#333333',
  },
  fonts: {
    primary: "'Roboto', sans-serif",
    secondary: "'Roboto Condensed', sans-serif",
    // ... other fonts
  },
  transitions: {
    standard: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    menu: 'right 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  zIndex: {
    header: 1000,
    mobileMenu: 2000,
    mobileMenuItem: 2001,
    backdrop: 1999,
  },
  shadows: {
    header: '0 4px 20px rgba(0, 0, 0, 0.2)',
  },
};